import dayjs from 'dayjs';

export const APP_MOUNT_DATE = new Date().toISOString();

export const getSecondsSinceAppMount = () => {
  const appMountDate = dayjs(APP_MOUNT_DATE);
  return dayjs().diff(appMountDate, 'seconds');
};

export const getSessionStartDate = () => {
  return sessionStorage.getItem('session-start-date') || APP_MOUNT_DATE;
};

export const getSecondsSinceSessionStart = () => {
  const sessionStartDate = dayjs(getSessionStartDate());
  return dayjs().diff(sessionStartDate, 'seconds');
};
